import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { colors } from '../color';
import { FaMapMarkerAlt, FaClock, FaCar, FaMotorcycle, FaBox, FaStar, FaApple, FaGooglePlay, FaMobileAlt, FaShieldAlt } from 'react-icons/fa';
import { ServerIP } from '../component/ServerIP';
import Loader from '../component/Loader';
import WarningComponent from '../component/WarningComponent';

const ClientAcceptCourse = () => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('orderId');

    const [missionData, setMissionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMissionData = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${ServerIP}/mission/getOneMissions/${orderId}`);
            setMissionData(response.data.mission);
        } catch (err) {
            setError('Impossible de charger les détails de la course.');
            console.error('Erreur:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (orderId) {
            fetchMissionData();
        } else {
            setError("Aucun numéro de commande fourni.");
            setLoading(false);
        }
    }, [orderId]);

    const formatPrice = (price) => {
        return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    // Inject styles for animations
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.innerText = `
            @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
            
            @keyframes fadeIn {
                from { opacity: 0; transform: translateY(10px); }
                to { opacity: 1; transform: translateY(0); }
            }
            @keyframes slideUp {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0); }
            }
            @keyframes pulse {
                0% { transform: scale(1); box-shadow: 0 0 0 0 ${colors.accent}66; }
                70% { transform: scale(1.02); box-shadow: 0 0 0 10px ${colors.accent}00; }
                100% { transform: scale(1); box-shadow: 0 0 0 0 ${colors.accent}00; }
            }
            @keyframes float {
                0% { transform: translateY(0px); }
                50% { transform: translateY(-5px); }
                100% { transform: translateY(0px); }
            }
            .store-btn:hover {
                transform: translateY(-2px);
                box-shadow: 0 15px 30px -5px rgba(0, 0, 0, 0.2) !important;
            }
            .glass-card {
                background: rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(10px);
                -webkit-backdrop-filter: blur(10px);
                border: 1px solid rgba(255, 255, 255, 0.2);
                box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07) !important;
            }
            @keyframes bounce {
                0%, 100% { transform: translateY(0); }
                50% { transform: translateY(-20px); }
            }
            .loading-letter {
                display: inline-block;
                font-size: 48px;
                font-weight: 800;
                color: ${colors.black};
                animation: bounce 1s infinite ease-in-out;
                margin: 0 2px;
            }
            .loading-letter:nth-child(1) { animation-delay: 0.0s; }
            .loading-letter:nth-child(2) { animation-delay: 0.1s; }
            .loading-letter:nth-child(3) { animation-delay: 0.2s; }
            .loading-letter:nth-child(4) { animation-delay: 0.3s; }
            .loading-letter:nth-child(5) { animation-delay: 0.4s; }
        `;
        document.head.appendChild(styleSheet);
        return () => {
            document.head.removeChild(styleSheet);
        };
    }, []);

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: "'Outfit', sans-serif",
                overflow: 'hidden',
                position: 'relative',
            }}>
                {/* Decorative background blobs */}
                <div style={{
                    position: 'absolute',
                    top: '-20%',
                    right: '-50%',
                    width: '150%',
                    height: '150%',
                    background: `radial-gradient(circle, ${colors.accent}26 0%, transparent 60%)`,
                    zIndex: 0,
                    pointerEvents: 'none',
                }}></div>
                <div style={{
                    position: 'absolute',
                    bottom: '-10%',
                    left: '-20%',
                    width: '120%',
                    height: '120%',
                    background: `radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, transparent 70%)`,
                    zIndex: 0,
                    pointerEvents: 'none',
                }}></div>
                <div style={{ position: 'relative', zIndex: 1 }}>
                    <span className="loading-letter">K</span>
                    <span className="loading-letter">I</span>
                    <span className="loading-letter">W</span>
                    <span className="loading-letter">U</span>
                    <span className="loading-letter">I</span>
                </div>
            </div>
        );
    }


    if (error || !missionData) {
        return (
            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: "'Outfit', sans-serif",
                padding: '20px',
                overflow: 'hidden',
                position: 'relative',
            }}>
                {/* Decorative background blobs */}
                <div style={{
                    position: 'absolute',
                    top: '-20%',
                    right: '-50%',
                    width: '150%',
                    height: '150%',
                    background: `radial-gradient(circle, ${colors.accent}26 0%, transparent 60%)`,
                    zIndex: 0,
                    pointerEvents: 'none',
                }}></div>
                <div style={{
                    position: 'absolute',
                    bottom: '-10%',
                    left: '-20%',
                    width: '120%',
                    height: '120%',
                    background: `radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, transparent 70%)`,
                    zIndex: 0,
                    pointerEvents: 'none',
                }}></div>
                <div className="glass-card" style={{
                    textAlign: 'center',
                    padding: '40px',
                    borderRadius: '24px',
                    maxWidth: '400px',
                    width: '90%',
                    position: 'relative',
                    zIndex: 1,
                }}>
                    <div style={{
                        fontSize: '48px',
                        color: colors.accent,
                        marginBottom: '20px',
                        animation: 'float 3s ease-in-out infinite'
                    }}>
                        <FaShieldAlt />
                    </div>
                    <h3 style={{
                        fontSize: '20px',
                        fontWeight: '700',
                        marginBottom: '10px',
                        color: '#1e293b'
                    }}>Oups !</h3>
                    <p style={{
                        color: '#64748b',
                        marginBottom: '24px',
                        lineHeight: '1.5'
                    }}>{error || "Impossible de trouver la mission demandée."}</p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            background: colors.black,
                            color: 'white',
                            border: 'none',
                            padding: '12px 24px',
                            borderRadius: '12px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'transform 0.2s',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    >
                        Réessayer
                    </button>
                </div>
            </div>
        );
    }

    // Determine Icon based on mission type
    const MissionIcon = missionData.type === 'Livraison' ? FaBox : (missionData.vehicleType === 'Voiture' ? FaCar : FaMotorcycle);
    const productImage = missionData.products && missionData.products.length > 0 ? missionData.products[0].image : null;

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #f0f4f8 0%, #d9e2ec 100%)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontFamily: "'Outfit', sans-serif",
            padding: '20px',
            color: '#1e293b',
            overflow: 'hidden', // Prevent scrollbars from decorative elements
            position: 'relative', // Ensure absolute children are contained if needed
        }}>
            <div style={{
                width: '100%',
                maxWidth: '440px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                animation: 'fadeIn 0.6s ease-out',
                position: 'relative',
                zIndex: 1,
            }}>
                {/* Decorative background blob moved to main container */}
                <div style={{
                    position: 'absolute',
                    top: '-20%',
                    right: '-50%',
                    width: '150%',
                    height: '150%',
                    background: `radial-gradient(circle, ${colors.accent}26 0%, transparent 60%)`,
                    zIndex: -1,
                    pointerEvents: 'none',
                }}></div>

                {/* Header Section */}
                <header style={{
                    textAlign: 'center',
                    marginBottom: '30px',
                    width: '100%',
                }}>
                    <div style={{
                        marginBottom: '24px',
                        display: 'inline-flex',
                        padding: '12px',
                        borderRadius: '24px',
                        backgroundColor: colors.accent,
                        boxShadow: `0 20px 40px -10px ${colors.accent}66`,
                        animation: 'float 6s ease-in-out infinite',
                    }}>
                        <h1 style={{
                            fontSize: '24px',
                            fontWeight: '800',
                            margin: 0,
                            letterSpacing: '-0.5px',
                            color: colors.black,
                            padding: '0 12px',
                        }}>Kiwui</h1>
                    </div>
                    <h2 style={{
                        fontSize: '36px',
                        fontWeight: '800',
                        marginBottom: '16px',
                        lineHeight: '1.1',
                        background: 'linear-gradient(to right, #0f172a, #334155)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        letterSpacing: '-1px',
                    }}>Commande prête !</h2>
                    <p style={{
                        fontSize: '17px',
                        color: '#64748b',
                        lineHeight: '1.6',
                        margin: 0,
                        fontWeight: '500',
                        padding: '0 20px',
                    }}>Téléchargez l'application pour confirmer et suivre votre colis en temps réel.</p>
                </header>

                {/* Mission Card */}
                <div className="glass-card" style={{
                    borderRadius: '32px',
                    padding: '32px',
                    width: 'calc(100% - 0px)',
                    marginBottom: '40px',
                    position: 'relative',
                    overflow: 'visible',
                    animation: 'slideUp 0.8s ease-out 0.2s backwards',
                }}>


                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '30px',
                        position: 'relative',
                        zIndex: 1,
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#FFFFFF',
                            color: colors.black,
                            padding: '10px 16px',
                            borderRadius: '16px',
                            fontWeight: '700',
                            fontSize: '14px',
                            border: '1px solid #e2e8f0',
                        }}>
                            <MissionIcon style={{ marginRight: '8px', fontSize: '16px' }} />
                            {missionData.type}
                        </div>
                        <div style={{
                            fontSize: '28px',
                            fontWeight: '800',
                            color: '#0f172a',
                            letterSpacing: '-1px',
                        }}>
                            {formatPrice(missionData.price)} <span style={{ fontSize: '16px', color: '#64748b', fontWeight: '600' }}>HTG</span>
                        </div>
                    </div>

                    {/* Product Image Section */}
                    {productImage && (
                        <div style={{
                            width: '65%',
                            height: '200px',
                            borderRadius: '7px',
                            overflow: 'hidden',
                            marginBottom: '30px',
                            position: 'relative',
                            boxShadow: '0 20px 40px -10px rgba(0,0,0,0.1)',
                            border: '1px solid rgba(0,0,0,0.05)',
                        }}>
                            <img src={productImage} alt="Produit" style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                transition: 'transform 0.5s ease',
                            }} />
                            {missionData.products.length > 1 && (
                                <div style={{
                                    position: 'absolute',
                                    bottom: '12px',
                                    right: '12px',
                                    backgroundColor: 'rgba(15, 23, 42, 0.8)',
                                    color: 'white',
                                    padding: '6px 12px',
                                    borderRadius: '12px',
                                    fontSize: '13px',
                                    fontWeight: '700',
                                    backdropFilter: 'blur(8px)',
                                }}>+{missionData.products.length - 1}</div>
                            )}
                        </div>
                    )}

                    <div style={{
                        position: 'relative',
                        marginBottom: '30px',
                        paddingLeft: '8px',
                        zIndex: 1,
                    }}>
                        {/* Connecting Line */}
                        <div style={{
                            position: 'absolute',
                            left: '19px',
                            top: '24px',
                            bottom: '45px',
                            width: '2px',
                            background: 'linear-gradient(to bottom, #cbd5e1 0%, #cbd5e1 50%, transparent 100%)',
                            zIndex: 0,
                        }}></div>

                        {/* Pickup */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            marginBottom: '24px',
                            position: 'relative',
                            zIndex: 1,
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '20px',
                                width: '24px',
                                height: '24px',
                                flexShrink: 0,
                            }}>
                                <div style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    backgroundColor: colors.accent,
                                    boxShadow: '0 0 0 3px #000000',
                                }}></div>
                            </div>
                            <div>
                                <span style={{
                                    fontSize: '12px',
                                    textTransform: 'uppercase',
                                    color: '#94a3b8',
                                    fontWeight: '700',
                                    letterSpacing: '1px',
                                    marginBottom: '4px',
                                    display: 'block',
                                }}>Départ</span>
                                <p style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#0f172a',
                                    margin: 0,
                                    lineHeight: '1.4',
                                }}>{missionData.pickupAddress}</p>
                            </div>
                        </div>

                        {/* Dropoff */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            position: 'relative',
                            zIndex: 1,
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '20px',
                                width: '24px',
                                height: '24px',
                                flexShrink: 0,
                            }}>
                                <FaMapMarkerAlt style={{ color: colors.secondary, fontSize: '20px', filter: 'drop-shadow(0 4px 6px rgba(144, 126, 255, 0.3))' }} />
                            </div>
                            <div>
                                <span style={{
                                    fontSize: '12px',
                                    textTransform: 'uppercase',
                                    color: '#94a3b8',
                                    fontWeight: '700',
                                    letterSpacing: '1px',
                                    marginBottom: '4px',
                                    display: 'block',
                                }}>Destination</span>
                                <p style={{
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#0f172a',
                                    margin: 0,
                                    lineHeight: '1.4',
                                }}>{missionData.deliveredAddress || "Adresse de destination"}</p>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        backgroundColor: '#f8fafc',
                        borderRadius: '24px',
                        padding: '20px',
                        border: '1px solid #e2e8f0',
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '14px',
                            color: '#475569',
                            fontWeight: '600',
                        }}>
                            <div style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '10px',
                                backgroundColor: colors.accent,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '12px',
                                color: colors.black,
                            }}>
                                <FaClock />
                            </div>
                            <span>{missionData.duration || "15 min"}</span>
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '14px',
                            color: '#475569',
                            fontWeight: '600',
                        }}>
                            <div style={{
                                width: '32px',
                                height: '32px',
                                borderRadius: '10px',
                                backgroundColor: colors.accent,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '12px',
                                color: colors.black,
                            }}>
                                <FaShieldAlt />
                            </div>
                            <span>Sécurisé</span>
                        </div>
                    </div>
                </div>

                {/* Call to Action Section */}
                <div style={{
                    textAlign: 'center',
                    width: '100%',
                    animation: 'slideUp 0.8s ease-out 0.4s backwards',
                }}>
                    <h3 style={{
                        color: '#1e293b',
                        fontSize: '20px',
                        fontWeight: '700',
                        marginBottom: '24px',
                        letterSpacing: '-0.5px',
                    }}>Téléchargez l'application</h3>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                    }}>
                        <a href="https://play.google.com/store/apps/details?id=com.frostie_03.kiwuidriver" target="_blank" rel="noopener noreferrer" style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: colors.black,
                            color: 'white',
                            textDecoration: 'none',
                            padding: '16px 24px',
                            borderRadius: '20px',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            cursor: 'pointer',
                            justifyContent: 'center',
                            boxShadow: '0 10px 25px -5px rgba(15, 23, 42, 0.25)',
                            border: '1px solid rgba(255,255,255,0.1)',
                            position: 'relative',
                            overflow: 'hidden',
                        }} className="store-btn">
                            <FaGooglePlay style={{
                                fontSize: '28px',
                                marginRight: '16px',
                                color: colors.accent,
                            }} />
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                            }}>
                                <span style={{
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    opacity: 0.8,
                                    fontWeight: '700',
                                    letterSpacing: '1px',
                                    marginBottom: '2px',
                                    color: colors.accent,
                                }}>Disponible sur</span>
                                <span style={{
                                    fontSize: '18px',
                                    fontWeight: '700',
                                    lineHeight: '1',
                                }}>Google Play</span>
                            </div>
                        </a>
                        <a href="https://apps.apple.com/us/app/kiwui/id6752814338" target="_blank" rel="noopener noreferrer" style={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#ffffff',
                            color: '#0f172a',
                            textDecoration: 'none',
                            padding: '16px 24px',
                            borderRadius: '20px',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            cursor: 'pointer',
                            justifyContent: 'center',
                            boxShadow: '0 10px 25px -5px rgba(148, 163, 184, 0.25)',
                            border: '1px solid #e2e8f0',
                        }} className="store-btn">
                            <FaApple style={{
                                fontSize: '32px',
                                marginRight: '16px',
                            }} />
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                            }}>
                                <span style={{
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    color: '#64748b',
                                    fontWeight: '700',
                                    letterSpacing: '1px',
                                    marginBottom: '2px',
                                }}>Télécharger dans</span>
                                <span style={{
                                    fontSize: '18px',
                                    fontWeight: '700',
                                    lineHeight: '1',
                                }}>L'App Store</span>
                            </div>
                        </a>
                    </div>
                </div>

                {/* Footer */}
                <footer style={{
                    marginTop: '40px',
                    color: '#94a3b8',
                    fontSize: '13px',
                    fontWeight: '500',
                    textAlign: 'center',
                    animation: 'fadeIn 1s ease-out 0.8s backwards',
                }}>
                    <p>© 2025 Kiwui Technologies. Tous droits réservés.</p>
                </footer>
            </div>
        </div>
    );
};

export default ClientAcceptCourse;